import { render, staticRenderFns } from "./scope134.vue?vue&type=template&id=0dcd9bf8&scoped=true"
import script from "./scope134.vue?vue&type=script&lang=js"
export * from "./scope134.vue?vue&type=script&lang=js"
import style0 from "./scope134.vue?vue&type=style&index=0&id=0dcd9bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcd9bf8",
  null
  
)

export default component.exports